// extracted by mini-css-extract-plugin
export default {"root":"Du5u8mGZ","root__vkcom":"AZeJcpZ8","in":"SX8pm4Uo","dot":"gTLskjmr","typing-icon-animation":"m2YPmppq","dotFirst":"uadiYN7v","dotSecond":"bAlFLFnM"};